import { StyledBox, StyledMessage } from './Error.styled';

export const Error = () => {
  return (
    <StyledBox>
      <StyledMessage>Error. Contacts not found</StyledMessage>
    </StyledBox>
  );
};
